export const Pancake = [
  'function approve(address token, address spender, uint160 amount, uint48 expiration)'
]
